import { useQuery } from '@tanstack/react-query';
import { getContact } from '../../api/apiContacts';

export const useGetContact = (id) => {
    return useQuery({
        queryKey: ['contact', id],
        queryFn: () => getContact(id),
        enabled: Boolean(id),
        retry: false,
    });
};